import React from 'react'
const ContenedorInput = ({col="", md="", sm="", extra="", label="", inputClass="", children, ...props}) =>
    <div style={props.style || {}} className={`form-group ${col ? `p-col-${col}` : "p-col"} p-md-${md} p-sm-${sm} ${extra}`}>
        <label>{label}</label>
        <div className={inputClass}>
            {children}
        </div>
    </div>;
export default ContenedorInput;